import { IconFont } from '@lighthouse/bui'
import styled from 'styled-components'

import * as CM from '../styles'

export const TitleRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 6px;
`

export const ExcelIconWrapper = styled.div`
    width: 24px;
    height: 24px;
    border-radius: 6px;
    background: #16a34a;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`

export const ExcelIcon = styled(IconFont)`
    font-size: 16px;
    color: var(--color-white);
`

export const TitleText = styled.div`
    font-size: 16px;
    font-weight: 700;
    color: var(--color-gray-900);
    line-height: 20px;
`

export const SectionLabel = styled.div`
    font-size: 12px;
    color: var(--color-gray-600);
    line-height: 20px;
    margin: 4px 0;
`

export const Icon = styled(CM.Icon)`
    font-size: 16px;
    color: var(--color-gray-500);
`

export const RichTextPreview = styled.div`
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 18px;
    font-size: 12px;
    color: var(--color-gray-900);
`

export const RightText = styled.div<{ $enabled?: boolean }>`
    font-size: 12px;
    color: ${({ $enabled }) => ($enabled ? 'var(--color-gray-900)' : 'var(--color-gray-500)')};
`
